import { ReactTFC, UnwrapReactComponent } from "../../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";

import { Link } from "react-router";
import React from "react";
import { RelatedArticleSetComponent } from "../RelatedArticleSetComponent";
import { inBoxBigHeadline, inBoxSmallHeadline } from "../shared-styles";
import { CSS_MQ } from "../../../styles/breakpoints";
import { T } from "../../T";

export const RelatedArticleSetLeftBox: ReactTFC<
  Required<UnwrapReactComponent<typeof RelatedArticleSetComponent>["left"]>
> = props => {
  return (
    <Link
      to={{ pathname: props.link }}
      state={{ scrollToTop: true }}
      css={css`
        background-color: var(--so-green-dark);

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        cursor: pointer;

        padding: 50px;

        ${CSS_MQ.atMostSm} {
          min-height: 15em;
          margin-bottom: 2px;
        }
      `}
    >
      <span css={inBoxSmallHeadline}>
        <T>{props.descriptiveHeadline}</T>
      </span>
      <span css={inBoxBigHeadline}>
        <T>{props.emoHeadline}</T>
      </span>
    </Link>
  );
};
